<div class="flex flex-col max-h-[85vh] p-3">
    <div class="flex shrink-0 mr-4 items-center justify-between">
        <h1 class="p-5 font-semibold text-base">
            @if(data.customTitle){
            {{data.customTitle}}
            }
            @else{
            Upload Historical Documents
            }
        </h1>
        <app-button variant="filled" severity="ghost" icon="pi pi-times" (clicked)="onCloseDialog()" />

    </div>

    <div class="flex flex-1 min-h-0 flex-col p-4 overflow-hidden">
        @if(!initiateUpload){
        <app-file-drop (uploadData)="file= $event" (removeFile)="onFileRemove($event)" [type]="type"
            [fileTypes]="allowedFileTypes" [maxFileSize]="100 * 1000 * 1000" [class]="dragAreaClass" [multiple]="true"
            (isFileadded)="onFileAddedChange($event)" [existingFiles]="getFilesArray()"></app-file-drop>
        }
        @if(isFileAdded && initiateUpload){
        <div class="w-[27rem] ">
            <div class="flex flex-col gap-2">
                <p class="text-base text-center mt-1 font-medium">This process may take a while, please wait while files
                    are
                    uploading
                </p>
                <div class="card mt-2">
                    <p-progressBar mode="indeterminate" color="#FF6A2A" [style]="{'height': '6px '}" />
                </div>
            </div>
        </div>
        }
    </div>
    @if (!initiateUpload) {
    <div class="m-2 flex justify-end items-center gap-2 shrink-0 ">
        <app-button variant="outlined" severity="contrast" label="Cancel" icon="pi pi-times"
            (clicked)="onCloseDialog()" />
        <app-button variant="filled" severity="primary" label="Upload" icon="pi pi-upload" (clicked)="uploadFiles()"
            [disabled]="!isFileAdded" />
    </div>
    }
</div>